"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var Block_1 = require("./Block");

var utils_1 = require("../utils");

var StyledBlock = styled_components_1.default(Block_1.Block)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      variant = _a.variant,
      size = _a.size;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), utils_1.getComponentThemeStyles(theme, 'Alert', variant, size));
});

function Alert(_a) {
  var children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'default' : _c,
      rest = __rest(_a, ["children", "variant", "size"]);

  return React.createElement(StyledBlock, __assign({
    variant: variant,
    size: size
  }, rest), children);
}

exports.Alert = Alert;
var templateObject_1, templateObject_2;